import Navigation from './Navigation.component';

export default Navigation;
